import React, {
    useEffect,
    useState,
} from 'react';

import useMediaConfig from '../hooks/config/useMediaConfig';
import { useDebounce } from './useDebounce';

import {
    request,
    processSuggestions
} from '../utils';

const useSuggestions = ({
    value,
    noResultsPlaceholder = [],
    debouncedDelay = 200,
    suggestionsEndpoint,
    queryParams,
    suggestionKeys,
    displayCount,
    excludeSuggestions,
}) => {

    const config = useMediaConfig() ?? {};
    const queryString = new URLSearchParams(queryParams).toString();
    suggestionsEndpoint = suggestionsEndpoint || config.suggestionsEndpoint;

    const [
        suggestions,
        setSuggestions,
    ] = useState([]);

    const debouncedValue = useDebounce(value, debouncedDelay);

    useEffect(() => {

        if (debouncedValue) {

            request(`${suggestionsEndpoint}${debouncedValue}${queryString ? '?q=' + queryString : ''}`)
                .then(result => {

                    const suggestions = processSuggestions({
                        suggestions: result,
                        suggestionKeys,
                        displayCount,
                        excludeSuggestions,
                    });
                    const suggestionsContent = suggestions.length
                        ? suggestions
                        : noResultsPlaceholder;
                    setSuggestions(suggestionsContent);

                });

        }

    }, [debouncedValue]);

    const clearSuggestions = () => {

        setSuggestions([]);

    };

    return {
        suggestions,
        clearSuggestions,
    };

};

export default useSuggestions;
